<svg:circle class="score-arc-background" cx="0" cy="0" [attr.r]="construct.radius - STROKE_WIDTH"></svg:circle>
<svg:text class="construct-score-number" x="0" [attr.y]="score && score.weightedRevisedOnly ? '-0.3em' : '0.35em'">{{ score ? (score.initialPercent + '%') : 'N/A' }}</svg:text>
<svg:text class="construct-score-number revised-score" x="0" *ngIf="score && score.weightedRevisedOnly" y="1em">{{ score.weightedPercent }}%</svg:text>
<svg:g class="score-group"></svg:g>
